app.directive('passwordmix', [function () {
    return {
        require: "?ngModel",
        link: function (scope, element, attrs, ctrl) {
            ctrl.$validators.passwordmix = function (modelValue, viewValue) {

                var isValid = 0;

                if (/[0-9]/.test(modelValue)) {
                    isValid++;
                } else {
                    isValid--;
                }

                if (/[a-z]/i.test(modelValue)) {
                    isValid++;
                } else {
                    isValid--;
                }

                return isValid === 2;
            }

        }
    };
}]);
